import Hero from "../components/Hero";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div className="flex flex-col">

      {/* 🔥 HERO PRINCIPAL */}
      <Hero />

      {/* 🚀 SECCIÓN DESTACADA FULL-WIDTH */}
      <section className="w-full bg-gray-50 py-20">
        <motion.div 
          data-aos="fade-up"
          className="max-w-6xl mx-auto px-6 text-center"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Elevate Your Business with Modern Technology
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            We develop tailored digital solutions to help your company grow, operate efficiently,
            and reach more customers through professional and scalable systems.
          </p>
        </motion.div>
      </section>

      {/* 🛠 SERVICIOS PRINCIPALES (full width pero contenido centrado) */}
      <section className="w-full bg-white">
        <motion.div
          data-aos="fade-up"
          className="mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <Services />
        </motion.div>
      </section>

      {/* ⭐ TESTIMONIOS (fondo alternado para mejor flujo visual) */}
      <section className="w-full bg-gray-50">
        <motion.div
          data-aos="fade-up"
          className="mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <Testimonials />
        </motion.div>
      </section>

      {/* 📩 CALL TO ACTION FINAL – FULL WIDTH PRO */}
      <section className="w-full bg-gradient-to-r from-blue-600 to-indigo-700 py-24">
        <motion.div
          className="max-w-6xl mx-auto px-6 text-center text-white"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-lg mb-8 text-blue-100 max-w-xl mx-auto">
            Request your personalized quote today and discover how 
            The Kaizen Business Solutions can help you grow.
          </p>

          <a
            href="/contact"
            className="bg-white text-blue-700 font-semibold px-8 py-3 rounded-lg shadow-lg hover:bg-blue-50 transition"
          >
            Request a Quote
          </a>
        </motion.div>
      </section>

    </div>
  );
}
